import { Component, Input } from '@angular/core';

@Component({
  selector: 'mac-avatar',
  standalone: false,
  template: `<nz-avatar class="uppercase" [nzText]="text" />`,
})
export class AvatarComponent {
    @Input() text?: string;
}

